import BankStatementUpload from './BankStatementUpload';

export default BankStatementUpload;
